import { useState, useEffect } from 'react'
import DataTable from './DataTable'
import { KTSVG } from '../../_metronic/helpers'
import Swal from 'sweetalert2'
import Select from 'react-select'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import { Form, Button } from 'react-bootstrap'

function SimilarItemList() {
    const hasPermission = 1;
    const [newData, setNewData] = useState({});
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState<{ label: string; value: number | string } | null>(null);
    const [selectedSimilarItem, setSelectedSimilarItem] = useState<{ label: string; value: number | string } | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        getItems();
    }, []);

    const getItems = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'production-items',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                // production-items returns items where is_product = 'No' (Item model)
                const list = (resp.data || resp).map((item: any) => ({
                    ...item,
                    label: (item.itemName || item.item_name) + ' - ID # ' + (item.idItems ?? item.id_items),
                    value: item.idItems ?? item.id_items
                }));
                setItems(list);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop');
            });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        if (!selectedItem || !selectedSimilarItem) {
            Swal.fire({
                icon: 'warning',
                title: 'Validation Error',
                text: 'Please select both Item and Similar Item',
            });
            return;
        }

        if (selectedItem.value === selectedSimilarItem.value) {
            Swal.fire({
                icon: 'warning',
                title: 'Validation Error',
                text: 'Item and Similar Item cannot be the same',
            });
            return;
        }

        setIsSubmitting(true);

        const payload = {
            id_items: selectedItem.value,
            id_second_items: selectedSimilarItem.value,
        };

        fetch(
            process.env.REACT_APP_API_URL + 'similar-items/store',
            postRequestOptions(payload)
        )
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: 'Similar items relationship created successfully',
                    });
                    setSelectedItem(null);
                    setSelectedSimilarItem(null);
                    setNewData({ id: Date.now() });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: resp.message || 'Failed to create similar items relationship',
                    });
                }
            })
            .catch((error) => {
                console.log(error, 'catch the hoop');
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while creating similar items relationship',
                });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const deleteSimilarItem = (id: number): void => {
        if (window.confirm("Are you sure you want to delete this similar item relationship?")) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}similar-items/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
                .then((resp: Response) => resp.json())
                .then((resp: any) => {
                    if (resp.success) {
                        const successMsg: string = resp.successMessage;
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted!',
                            text: successMsg,
                        });
                        setNewData({ id: Date.now() });
                    }
                })
                .catch((error: any) => {
                    console.log(error, 'catch the hoop');
                });
        }
    };

    const columns = [
        { value: 'id_similar_items', title: 'Id', style: { textAlign: 'center' } },
        { value: 'itemName', title: 'Item', style: { textAlign: 'left' } },
        { value: 'similarItemName', title: 'Similar Item', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <button className="btn btn-light-danger btn-sm p-2" onClick={() => deleteSimilarItem(row.id_similar_items)}>
                            <KTSVG
                                path='/media/svg/icons/General/Trash.svg'
                                className='svg-icon-5 svg-icon'
                            />		Delete
                        </button>
                    </>
                )
            })
        }
    ]

    const filters = {
        id_similar_items: {
            filterType: 'like',
            filterValue: '',
        },
        itemName: {
            filterType: 'like',
            filterValue: '',
        },
        similarItemName: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'similar-items'

    return (
        <>
            {hasPermission === 1 &&
                <div className='card card-custom'>
                    <div className='card-header'>
                        <div className="card-title">
                            <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                            <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                Similar Items List
                            </span>
                        </div>
                    </div>

                    <div className='card-body'>
                        {/* Form Section */}
                        <div className='mb-5'>
                            <Form onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className='col-md-5'>
                                        <Form.Group className='mb-3'>
                                            <Form.Label>Select Item</Form.Label>
                                            <Select
                                                value={selectedItem}
                                                onChange={(option) => setSelectedItem(option)}
                                                options={items}
                                                placeholder="Select Item"
                                                isClearable
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className='col-md-5'>
                                        <Form.Group className='mb-3'>
                                            <Form.Label>Select Similar Item</Form.Label>
                                            <Select
                                                value={selectedSimilarItem}
                                                onChange={(option) => setSelectedSimilarItem(option)}
                                                options={items}
                                                placeholder="Select Similar Item"
                                                isClearable
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className='col-md-2'>
                                        <Form.Group className='mb-3'>
                                            <Form.Label>&nbsp;</Form.Label>
                                            <Button
                                                type="submit"
                                                variant="primary"
                                                className="w-100"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Saving...' : 'Save'}
                                            </Button>
                                        </Form.Group>
                                    </div>
                                </div>
                            </Form>
                        </div>

                        {/* DataTable Section */}
                        <DataTable url={url} columns={columns} filters={filters} newData={newData} />
                    </div>
                </div>
            }
        </>
    )
}

export default SimilarItemList
